<div>
    @if (!isLoading) {
        <form-linkable
            displayValueProp="name"
            [parentGuid]="parentGuid"
            [linkedModule]="linkedModule"
            [linkedForms]="linkedForms"
            [linked]="linked"
            [unlinked]="unlinked"
            [disabled]="disabled"
            [hideActions]="true"
            (linkedChange)="linkedItemsChanged($event)"
        ></form-linkable>
    }
</div>
